import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider } from './contexts/LanguageContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import { ThemeContextProvider, useThemeContext } from './contexts/ThemeContext';
import AdminLoginPage from './pages/AdminLoginPage';
import SetupPage from './pages/SetupPage';
import ProtectedRoute from './components/ProtectedRoute';

// Wrapper component to access theme from context
const AppWithTheme = () => {
  const { theme } = useThemeContext();
  
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/admin-login" element={<AdminLoginPage />} />
        <Route
          path="/admin-setup"
          element={
            <ProtectedRoute>
              <SetupPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <LanguageProvider>
        <AdminAuthProvider>
          <ThemeContextProvider>
            <AppWithTheme />
          </ThemeContextProvider>
        </AdminAuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
